import { render } from "./general-configuration.vue?vue&type=template&id=79f3bb21"
import script from "./general-configuration.vue?vue&type=script&lang=js"
export * from "./general-configuration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__